<div class="modal-header" id="equipment-configuration-modal-title">
    <h3 class="modal-title" id="modal-title" [translate]="'PHYSICAL_INVENTORY_TITLE'"></h3>
</div>
<div class="modal-body">
    <form [formGroup]="physicalInventoryForm">
        <fieldset>
            <div class="row mb-2">
                <div class="col-12">
                    <tabset type="pills" paceCoreTabsRole>
                        <tab [heading]="headingStrings.measurementTools">
                            <pace-pi-measurement-tool
                                [model]="model.measurementTools"
                                [parentForm]="physicalInventoryFormChildren"
                            ></pace-pi-measurement-tool>
                        </tab>
                        <tab [heading]="headingStrings.spareParts">
                            <pace-pi-spare-part
                                [model]="model.materials"
                                [parentForm]="physicalInventoryFormChildren"
                            ></pace-pi-spare-part>
                        </tab>
                    </tabset>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <button
        class="btn btn-warning"
        type="button"
        (click)="closeModal()"
        [translate]="'PHYSICAL_INVENTORY_CLOSE_LABEL'"
    ></button>
    <button
        class="btn btn-primary"
        type="button"
        [disabled]="physicalInventoryForm.invalid && !isLoading"
        [translate]="'PHYSICAL_INVENTORY_SUBMIT_LABEL'"
        (click)="submit()"
    ></button>
    @if (isLoading) {
        <progressbar [striped]="true" [value]="100">
            {{ 'PHYSICAL_INVENTORY_SUBMIT_IN_PROGRESS_LABEL' | translate }}
        </progressbar>
    }
</div>
